import { render, staticRenderFns } from "./BLPaymentPop.vue?vue&type=template&id=4a4e82ba"
import script from "./BLPaymentPop.vue?vue&type=script&lang=js"
export * from "./BLPaymentPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a4e82ba')) {
      api.createRecord('4a4e82ba', component.options)
    } else {
      api.reload('4a4e82ba', component.options)
    }
    module.hot.accept("./BLPaymentPop.vue?vue&type=template&id=4a4e82ba", function () {
      api.rerender('4a4e82ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLPaymentPop.vue"
export default component.exports